import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["isDisabled", "id", "value", "variant", "onChange"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import React from 'react';
import { useTranslation } from 'react-i18next';
import FormField from 'components/FormField';
import { Select, Option } from 'components/Select';
import useUniqueId from 'hooks/useUniqueId';
import { jsx as _jsx } from "react/jsx-runtime";
function DownloadPermissionField(_ref) {
  var isDisabled = _ref.isDisabled,
    id = _ref.id,
    value = _ref.value,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'transparent' : _ref$variant,
    _onChange = _ref.onChange,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var uniqueId = useUniqueId(id);
  var downloadOptions = [{
    value: 'disabled',
    title: t('state_disabled')
  }, {
    value: 'enabled',
    title: t('state_enabled')
  }, {
    value: 'required',
    title: t('state_required_no_file_preview')
  }];
  return /*#__PURE__*/_jsx(FormField, _objectSpread(_objectSpread({
    as: "span",
    label: t('form_allow_download'),
    labelId: uniqueId
  }, otherProps), {}, {
    children: /*#__PURE__*/_jsx(Select, {
      isDisabled: isDisabled,
      labelledById: uniqueId,
      size: "medium",
      variant: variant,
      menuPlacement: "top",
      value: value,
      onChange: function onChange(selectedItem) {
        return _onChange(selectedItem);
      },
      ml: variant === 'transparent' ? '-xxs' : undefined,
      children: downloadOptions.map(function (option) {
        return /*#__PURE__*/_jsx(Option, {
          value: option.value,
          children: option.title
        }, option.value);
      })
    })
  }));
}
export default DownloadPermissionField;